import * as React from 'react';
import styled from 'styled-components';
import {
  Checkbox
} from  "@material-ui/core";
import ExpandableProperty from './ExpandableProperty';



const RecursivePropertyContainer = styled.div`
  padding-top: 15px;
  padding-bottom: 5px; 
  //padding-left: 3px;
  margin-left: 0.5vw;
  ${(props) =>
    props.excludeBottomBorder ? '' : 'border-bottom: 1px solid #0C4D82;'}
  //color:  #0C4D82;    
  //font-size: 16px;
`;

export const PropertyName = styled.span`
  color: black;
  //font-size: 14px;
  font-weight: bold;
`;

const camelCaseToNormal = (str = 'string') => str.replace(/([A-Z])/g, ' $1').replace(/^./, str2 => str2.toUpperCase());

const RecursiveProperty = props => {
    
    const {
      selectedInputs,
      setSelectedInputs,
      excludeBottomBorder,
      property,
      propertyName,
      rootProperty
    } = props;

    const {parentProperty} = props;

    const handleClick = (label, value) => {

      const tempSelectedInputs = [...selectedInputs];

      let exists = -1;
      tempSelectedInputs.forEach( (pair, index) =>{
        if(pair[0] === parentProperty+label && pair[1] === value){
          exists = index;
        }
      })

      if(exists === -1){
        tempSelectedInputs.push([parentProperty+label,value]);
      }
      else{
        tempSelectedInputs.splice(exists,1);
      } 
           
      setSelectedInputs(tempSelectedInputs);


    }

    const hasClicked = (label,value) => {

      const tempSelectedInputs = [...selectedInputs];
      
      let exists = -1;
      tempSelectedInputs.forEach( (pair, index) =>{
        if(pair[0] === parentProperty+label && pair[1] === value){
          exists = index;
        }
      })
      
      return !(exists === -1 );

    }
  
    return (
    
        <RecursivePropertyContainer excludeBottomBorder={excludeBottomBorder}>
          {typeof property === 'number' || typeof property === 'string' || typeof property === 'boolean' ? (
            <>
              <PropertyName>{camelCaseToNormal(propertyName)}: </PropertyName>
              {property.toString()} &nbsp;
              <Checkbox checked={hasClicked(propertyName, property.toString())} onChange={() => handleClick(propertyName, property.toString())} inputProps={{ 'aria-label': 'uncontrolled-checkbox' }} />
            </>
          ) : Array.isArray(property) ? (
            <>
              <PropertyName>{camelCaseToNormal(propertyName)}:</PropertyName>
              {property.map((item, index) => (
                <RecursiveProperty
                  key={index}
                  property={item}
                  propertyName={index.toString()}
                  excludeBottomBorder={index === property.length - 1}
                  selectedInputs={selectedInputs}
                  setSelectedInputs={setSelectedInputs}
                  parentProperty={propertyName !== 'Root Property' ? `${parentProperty}${propertyName}[${index}]` : ''}
                />
              ))}
            </>
          ) : (property && typeof property === 'object') ? (
            <ExpandableProperty title={camelCaseToNormal(propertyName)} expanded={!!rootProperty}>
              {Object.entries(property).map(([key, value], index, array) => (
                <RecursiveProperty
                  key={index}
                  property={value}
                  propertyName={key}
                  excludeBottomBorder={index === array.length - 1}
                  selectedInputs={selectedInputs}
                  setSelectedInputs={setSelectedInputs}
                  parentProperty={propertyName === 'Root Property' ? ('') : parentProperty.endsWith(']') ? (`${parentProperty}.`) : (`${parentProperty}${propertyName}.`) }
                />
              ))}
            </ExpandableProperty>
          ) : null}
        </RecursivePropertyContainer>
      );
};


export default RecursiveProperty;